import { v4 as uuid } from "uuid";
import { Welder, WelderStatus } from "@/api/williams/welders";
import { WelderForm } from "./WelderForm";

export function CreateWelder() {
  const defaultValues: Welder = {
    welderId: uuid(),
    welderVersionId: uuid(),
    status: WelderStatus.Active,
    name: "",
    ssn: "",
    firstName: "",
    lastName: "",
    regions: [],
    advisories: [],
  };

  return <WelderForm data={defaultValues} />;
}
